import { Button } from '@cian/ui-kit';
import { IconActionCompareAdded16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

interface IComparisonButtonActiveProps {
  onClick(): void;
}

export const ComparisonButtonActive: React.FC<IComparisonButtonActiveProps> = ({ onClick }) => {
  return (
    <Button
      size="XS"
      theme="fill_secondary"
      data-mark="ComparisonControlActive"
      onClick={onClick}
      beforeIcon={<IconActionCompareAdded16 color="icon-main-default" />}
      aria-label="Удалить из сравнения"
      data-name="ComparisonControlActive"
      data-testid="ComparisonControlActive"
    />
  );
};
